module.exports = __webpack_public_path__ + "static/media/ico-facebook.4667a908.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-facebook.svg
// module id = 164
// module chunks = 0